import { OVER_QUOTA_MESSAGE } from "@lib/storage";

export function OverQuotaNotice() {
  return <span className="text-destructive">{OVER_QUOTA_MESSAGE}</span>;
}
